<template>
  <div class="BgLegend">
    <div class="BgLegend__emotion-holder">
      <div :class="`BgLegend__emotion BgLegend__emotion--attention`" />
      <div class="BgLegend__emotion-name">Attention</div>
    </div>
    <div class="BgLegend__emotion-holder">
      <div :class="`BgLegend__emotion BgLegend__emotion--joy`" />
      <div class="BgLegend__emotion-name">Joy</div>
    </div>
    <div class="BgLegend__emotion-holder">
      <div :class="`BgLegend__emotion BgLegend__emotion--frustration`" />
      <div class="BgLegend__emotion-name">Frustration</div>
    </div>
    <div class="BgLegend__emotion-holder" v-if="showManual">
      <div :class="`BgLegend__emotion BgLegend__emotion--manual`" />
      <div class="BgLegend__emotion-name">Feedback marker</div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import "./styles.scss";
</style>

<script>
export default {
  name: "BgLegend",
  props: {
    showManual: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
